import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import IonIcons from '@expo/vector-icons/Ionicons';
import Colors from '../constants/Colors';
import PropTypes from 'prop-types';

/**
 * For displaying a full-width item in a menu, typically the child of a
 * TouchableOpacity, with a name, description, and icon.
 */
export default function MenuItem(props) {
  return (
    <View style={styles.container}>
      <View>
        <Text style={styles.name}>{props.name}</Text>
        {props.description && <Text style={styles.description}>{props.description}</Text>}
      </View>
      <IonIcons name={props.icon} size={24} style={styles.icon} />
    </View>
  );
}

MenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 16,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  name: {
    fontSize: 16,
  },
  description: {
    fontSize: 12,
    color: Colors.grayText,
    marginTop: 4,
  },
  icon: {
    color: Colors.iconGray,
  },
});
